import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { AdminHeader, ConfirmDelete } from "../../components/admin/AdminUI";
import { CheckCircle2, Mail, Phone } from "lucide-react";
import { toast } from "sonner";

export default function MessagesAdmin() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/contact-messages").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const markRead = async (id) => { await api.put(`/admin/contact-messages/${id}/read`); load(); toast.success("Marked as read"); };
  const del = async (id) => { await api.delete(`/admin/contact-messages/${id}`); load(); toast.success("Deleted"); };
  return (
    <div>
      <AdminHeader title="Contact Messages" subtitle={`${items.length} messages, ${items.filter((m) => !m.is_read).length} unread`} />
      <div className="space-y-3">
        {items.map((m) => (
          <div key={m.id} className={`card-elev p-5 ${!m.is_read ? "border-l-4 border-l-brand-accent" : ""}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="font-semibold text-brand-text flex items-center gap-2">{m.name} {!m.is_read && <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-brand-accent text-white uppercase tracking-widest font-semibold">New</span>}</div>
                <div className="text-xs text-brand-muted mt-1 flex gap-3 flex-wrap">
                  <a href={`mailto:${m.email}`} className="flex items-center gap-1 hover:text-brand-primary"><Mail size={12} /> {m.email}</a>
                  {m.phone && <a href={`tel:${m.phone}`} className="flex items-center gap-1 hover:text-brand-primary"><Phone size={12} /> {m.phone}</a>}
                  <span>{new Date(m.created_at).toLocaleString()}</span>
                  <span className="px-2 py-0.5 rounded-full bg-brand-primary-light text-brand-primary font-semibold">{m.department || "General"}</span>
                </div>
              </div>
              <div className="flex items-center gap-1">
                {!m.is_read && <button onClick={() => markRead(m.id)} className="p-2 rounded-lg text-brand-accent hover:bg-brand-accent/10" title="Mark as read"><CheckCircle2 size={16} /></button>}
                <ConfirmDelete onConfirm={() => del(m.id)} />
              </div>
            </div>
            {m.subject && <div className="mt-3 font-semibold text-brand-text">{m.subject}</div>}
            <p className="mt-2 text-brand-muted text-sm whitespace-pre-line">{m.message}</p>
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-brand-muted py-16">No messages yet.</div>}
      </div>
    </div>
  );
}
